import PropTypes from 'prop-types';
import { Heading, Text } from '@/components/ui/index.js';
import styles from './FeatureCard.module.css';

/**
 * FeatureCard - Glassmorphic card for feature highlights
 * Includes icon, title, description with hover glow effects
 */
export function FeatureCard({ icon: Icon, title, description, delay = 0 }) {
  return (
    <article
      className={styles.card}
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className={styles.iconWrapper}>
        <Icon size={32} strokeWidth={1.5} className={styles.icon} />
      </div>
      <Heading level={3} size="md" color="primary" className={styles.title}>
        {title}
      </Heading>
      <Text size="base" color="secondary" leading="relaxed" className={styles.description}>
        {description}
      </Text>
      <div className={styles.glowEffect} />
    </article>
  );
}

FeatureCard.propTypes = {
  icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  delay: PropTypes.number,
};

export default FeatureCard;
